import { render } from "./SendEmailReceipt.vue?vue&type=template&id=4844b25d&ts=true"
import script from "./SendEmailReceipt.vue?vue&type=script&lang=ts"
export * from "./SendEmailReceipt.vue?vue&type=script&lang=ts"

import "./SendEmailReceipt.vue?vue&type=style&index=0&id=4844b25d&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__